export default __webpack_public_path__ + "static/media/home-consulting-parallax-bg.9a4ba7f3.jpg";